import { useGetMainPageUrl } from 'app-level/navigation';
import { MainRouteKeys } from 'app-level/navigation/navigation.config';
import { NavLink } from 'react-router-dom';
import { PngIcon } from 'ui-kit';

import { HeaderMenuItemConfig } from '../Header/headers.config';

interface PassedProps {
  tabDetails: HeaderMenuItemConfig<MainRouteKeys>;
}

const HeaderMenuItem = ({ tabDetails }: PassedProps) => {
  const getPath = useGetMainPageUrl();
  const { routeKey = 'home' } = tabDetails;

  // If routeKey is a valid main route key, use `getPath`
  const isMainRoute = ['home', 'portfolio', 'marketplace', 'market-data', 'account'].includes(
    routeKey,
  );

  const resolvedPath = isMainRoute
    ? getPath(routeKey as MainRouteKeys)
    : `/marketplace/${routeKey}`; // fallback for nested paths like 'active_trades/all'

  return (
    <div>
      <li className="flex list-none items-center">
        <NavLink
          to={resolvedPath}
          data-tour={routeKey === 'home' ? 'home-nav' : undefined}
          className={({ isActive }) =>
            [
              'mx-2 border-b-2 border-transparent-0 px-4 pb-0 pt-6',
              'flex items-center text-base text-foreground-default no-underline',
              isActive
                ? 'border-foreground-default opacity-100 light:border-black light:text-black'
                : 'border-transparent opacity-40 hover:opacity-100 light:text-gray-600 light:opacity-80 light:hover:text-black',
            ].join(' ')
          }
        >
          {tabDetails.iconName && <PngIcon name={tabDetails.iconName} size="extraLarge" />}
          <span className="pl-2">{tabDetails.label}</span>
        </NavLink>
      </li>
    </div>
  );
};

export default HeaderMenuItem;
